import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import {
    AllocationOverviewConfirmationCheck,
    Overview,
    SimulationOverview,
    MissingPartDetails,
    BookClosureDetails,
    SimulationMonthlyResponse,
} from "src/state/overview/state-models/overview-data";
import { Apollo, gql } from "apollo-angular";

@Injectable({
    providedIn: "root",
})
export class OverviewApiService {
    constructor(
        private http: HttpClient,
        private apollo: Apollo,
    ) {}

    GetByAllocationType(allocationType: number, productionDate?: string): Observable<Overview[]> {
        const url = `${environment.protectedResources.api.endpoint}/allocationoverview/byAllocationType`;
        const params: any = { allocationType: allocationType.toString() };
        if (productionDate) {
            params.productionDate = productionDate;
        }
        return this.http.get<Overview[]>(url, { params });
    }

    GetSimulation(): Observable<SimulationOverview> {
        const url = `${environment.protectedResources.api.endpoint}/allocationoverview/GetSimulation`;
        return this.http.get<SimulationOverview>(url);
    }
    GetBookClosureDetail(): Observable<BookClosureDetails[]> {
        const url = `${environment.protectedResources.api.endpoint}/allocationoverview/GetBookClosureDate`;
        return this.http.get<BookClosureDetails[]>(url);
    }

    GetSimulationMissingPart(from: string): Observable<MissingPartDetails[]> {
        const url = `${environment.protectedResources.api.endpoint}/allocationoverview/GetSimulationMissingPart`;
        const reqData = {
            FromDate: from,
        };
        return this.http.get<MissingPartDetails[]>(url, { params: reqData });
    }

    GetSimulationMonthlyData(): Observable<SimulationMonthlyResponse> {
        const url = `${environment.protectedResources.api.endpoint}/allocationoverview/GetSimulationMonthlyData`;
        return this.http.get<SimulationMonthlyResponse>(url);
    }

    SaveAllocationOverviewConfirmationCheck(
        payload: AllocationOverviewConfirmationCheck,
    ) {
        const mutation = `
        mutation saveAllocationOverviewConfirmationCheck($payload: AllocationOverviewConfirmationCheckInput!){
            allocationOverviewConfirmationCheck{
                saveAllocationOverviewConfirmationCheck(payload: $payload)
                {
                    scaniaUnitId
                    updatedBy
                    isCompleted
                }
            }
        }`;
        return this.apollo
            .mutate({
                mutation: gql(mutation),
                variables: { payload },
            })
            .toPromise();
    }
}
